class CustomAccessories extends HTMLElement {
    constructor() {
        super();
        this.selectedColors = [0, 0];
        this.selectedCableType = 0;
        this.secondTypeNumber = parseInt(this.querySelector(".second-type-number").textContent);

        this.querySelectorAll(".accessories__input:not(.new-accessories-input-color)").forEach((element, index) => element.addEventListener("click", () => { this.toggleActivation(element, index); }));
        this.querySelectorAll(".accessories__option").forEach((element, elementIndex) => element.querySelectorAll(".accessories__color--block").forEach((element,index) => element.addEventListener("click", () => { this.selectColor(element, elementIndex, index) }) ));
        this.querySelectorAll(".new-accessories-input-color").forEach((element, index) => element.addEventListener("click", () => { this.switchCableType(element, index) })); 
    }

    /*
        element = The main checkbox (.accessories__input) of a custom-accessory
        index = The index of the element (like: It's the first accessories__input field)
    */
    toggleActivation(element, index) {

        // UI handle
        let parentElement = element.closest(".accessories__option");
        // parentElement.querySelector(".custom-accessories-images").classList.toggle("custom-accessories-selected-element");
        // parentElement.querySelector(".custom-accessories-texts").classList.toggle("custom-accessories-selected-text");
        // parentElement.querySelectorAll(".accessories__color--block")[this.selectedColors[index]].classList.toggle("accessories__color--block--selected");

        // Product form handle
        let newQuantity = 1 - parseInt(document.querySelectorAll(".custom-accessory-quantity")[index].value);
        document.querySelectorAll(".custom-accessory-quantity")[index].value = newQuantity;
        // document.querySelectorAll(".custom-accessory-id")[elementIndex].value = parentElement.querySelectorAll(".item-id")[index].textContent;
    }

    /*
        element = The selected color picker element (.accessories__color--block)
        elementIndex = In which accessory picker is the picked color element 
        index = The selected color picker's index (Like in the second accessory picker, we chose the THIRD color)
    */
    selectColor(element, elementIndex, index) {

        // UI and data handle
        let parentElement = element.closest(".accessories__option");
        parentElement.querySelectorAll(".accessories__color--block--selected").forEach((element) => {
          element.classList.remove("accessories__color--block--selected");
        })
        this.selectedColors[elementIndex] = index;
        parentElement.querySelectorAll(".accessories__color--block")[index].classList.add("accessories__color--block--selected");
        parentElement.querySelector(".accessories__images").scrollLeft = 76 * index;
        parentElement.querySelector(".price--highlight").textContent = parentElement.querySelectorAll(".item-price")[index].textContent;
        parentElement.querySelector(".price--compare").textContent = parentElement.querySelectorAll(".item-compered-at-price")[index].textContent;

        // Product form handle
        if (document.querySelectorAll(".custom-accessory-id")[elementIndex])
          document.querySelectorAll(".custom-accessory-id")[elementIndex].value = parentElement.querySelectorAll(".item-id")[index].textContent;
        else
          document.querySelectorAll(".custom-accessory-id")[0].value = parentElement.querySelectorAll(".item-id")[index].textContent;
    }

    /*
        element = The cable selector input (.accessories__input)
        index = The index of the selected input (In this example (2023.06.12): USB C - 0, LIGHTNING - 1)
    */
    switchCableType(element, index) {
        if (index != this.selectedCableType) {
            this.querySelectorAll(".accessoryType-" + this.selectedCableType).forEach((element) => { element.classList.remove("accessories__color--block--selected"); element.style.display = "none"; });
            this.querySelectorAll(".new-accessories-input-color")[this.selectedCableType].checked = false;
            this.selectedCableType = 1 - this.selectedCableType;
            this.selectedColors[1] = this.selectedCableType * this.secondTypeNumber;
            this.querySelectorAll(".accessoryType-" + this.selectedCableType).forEach((element) => element.style.display = "block" );
            this.selectColor(element, 1, parseInt(this.selectedCableType * this.secondTypeNumber));
        } else {
            this.querySelectorAll(".new-accessories-input-color")[index].checked = true;
        }
    }

}

window.customElements.define("custom-accessories", CustomAccessories);